// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36aAm","right":"styles_right__OtcXy"};